import Vue from 'vue'
import Router from 'vue-router'
const Admin = () => import('@/contianers/admin')
const Public = () => import('@/contianers/full')

const ErrorView = () => import('@/pages/Error')
const Assessment = () => import('@/pages/Assessment')
const Aritnet = () => import('@/pages/Aritnet')
const WFHOnline = () => import('@/pages/Univ')
const Login = () => import('@/pages/Login')
const Users = () => import('@/pages/Users')
const Permission = () => import('@/pages/Permission')
const Rounds = () => import('@/pages/Rounds')
const RoundForm = () => import('@/pages/RoundForm')
const Groups = () => import('@/pages/Groups')
const Questions = () => import('@/pages/Questions')
const Reportfaculty = () => import('@/pages/Report_faculty')
const Reportgender = () => import('@/pages/Report_gender')
const Main = () => import('@/pages/Main')

Vue.use(Router)
const titlename = ' | สำนักวิทยบริการและเทคโนโลยีสารสนเทศ'
const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: '/survey/',
  routes: [
    {
      path: '/',
      redirect: '/',
      name: 'main',
      component: Public,
      children: [{
        path: '/',
        name: 'main',
        component: Main,
        meta: { title: 'ระบบประเมิน', id: '0' }
      },
      {
        path: '/assessment/:key',
        name: 'assessment',
        component: Assessment,
        meta: { title: 'แบบประเมิน', id: '0' }
      },
      {
        path: '/aritnet/:key',
        name: 'aritnet',
        component: Aritnet,
        meta: { title: 'แบบประเมิน', id: '0' }
      },
      {
        path: '/hotline/:key',
        name: 'WFHOnline',
        component: WFHOnline,
        meta: { title: 'แบบประเมิน', id: '0' }
      },
      {
        path: '/hotline/:key/:std',
        name: 'WFHOnline',
        component: WFHOnline,
        meta: { title: 'แบบประเมิน', id: '0' }
      }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin',
      name: 'dashboard',
      component: Admin,
      children: [{
        path: '/',
        name: 'users',
        component: Users,
        meta: { title: 'จัดการข้อมูลผู้ใช้งาน', id: '1', group: 's0' }
      },
      {
        path: '/admin/permission',
        name: 'permission',
        component: Permission,
        meta: { title: 'จัดการสิทธิ์การใช้งาน', id: '2', group: 's0' }
      },
      {
        path: '/admin/rounds',
        name: 'rounds',
        component: Rounds,
        meta: { title: 'จัดการรอบการประเมิน', id: '3', group: 's1' }
      },
      {
        path: '/admin/group',
        name: 'groups',
        component: Groups,
        meta: { title: 'จัดการกลุ่มคำถาม', id: '4', group: 's1' }
      },
      {
        path: '/admin/question',
        name: 'questions',
        component: Questions,
        meta: { title: 'จัดการข้อมูลคำถาม', id: '5', group: 's1' }
      },
      {
        path: '/admin/report_faculty',
        name: 'reportfaculty',
        component: Reportfaculty,
        meta: { title: 'รายงานจำแนกตามหน่วยงาน', id: '6', group: 's2' }
      },
      {
        path: '/admin/report_gender',
        name: 'reportgender',
        component: Reportgender,
        meta: { title: 'รายงานจำแนกตามเพศ', id: '7', group: 's2' }
      },
      {
        path: '/admin/roundform',
        name: 'roundform',
        component: RoundForm,
        meta: { title: 'แบบการประเมิน', id: '3', group: 's1' }
      },
      {
        path: '/admin/roundform/:round_id',
        name: 'roundform',
        component: RoundForm,
        meta: { title: 'แบบการประเมิน', id: '3', group: 's1' }
      }
      ]
    },
    {
      path: '/admin/login',
      name: 'login',
      component: Login,
      meta: { title: 'เข้าสู่ระบบ' }
    },
    {
      path: '*',
      name: 'error',
      component: ErrorView,
      meta: { title: 'ไม่พบข้อมูล' }
    }
  ]
})

const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js